import React from "react";
import { Edit, SaveButton, SimpleForm, TextInput, Toolbar } from "react-admin";
import COLORS from "../../theme/colors";
import { getInitials } from "../../theme/partials/AppBar";

const styles = {
  header: {
    display: "flex",
    alignItems: "center",
    marginBottom: 16
  },
  avatar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 64,
    height: 64,
    marginRight: 16,
    borderRadius: "50%",
    backgroundColor: COLORS.primary,
    color: "#fff",
    fontSize: 22,
    fontWeight: 700
  },
  name: {
    color: COLORS.text,
    fontSize: 18,
    fontWeight: 700
  },
  email: {
    marginTop: 2,
    color: COLORS.muted,
    fontSize: 14
  }
};

const ProfileHeader = ({ record }) => {
  const name = `${record.firstName || ""} ${record.lastName || ""}`.trim();

  return (
    <div style={styles.header}>
      <div style={styles.avatar}>{getInitials(name)}</div>
      <div>
        <div style={styles.name}>{name}</div>
        <div style={styles.email}>{record.email}</div>
      </div>
    </div>
  );
};

const ProfileToolbar = props => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

export const ProfileEdit = props => (
  <Edit title="pos.profile" {...props}>
    <SimpleForm redirect={false} toolbar={<ProfileToolbar />}>
      <ProfileHeader />
      <TextInput label="resources.misc.fields.firstName" source="firstName" />
      <TextInput label="resources.misc.fields.lastName" source="lastName" />
      <TextInput label="resources.misc.fields.email" source="email" />
    </SimpleForm>
  </Edit>
);
